import { useQuery } from "@tanstack/react-query";
import { getUserInfo } from "@/api/user";
import { UserInfo } from "@/interfaces/authentication";

const DelegationBanner = () => {
  const { data: userInfo } = useQuery<UserInfo>({
    queryKey: ["userInfo"],
    queryFn: getUserInfo,
  });

  if (!userInfo?.isDelegatedSession) {
    return null;
  }

  const lawyerName = userInfo.navn?.trim();
  const delegateName = userInfo.authenticatedMitIdName?.trim();

  return (
    <div
      id="delegation-session-banner"
      className="delegation-banner alert alert-info rounded-0 border-0 mb-0 d-flex align-items-center justify-content-center px-4 py-2"
      role="status"
      aria-live="polite"
    >
      <p className="mb-0 text-center fs-6">
        {lawyerName ? (
          <>
            Du handler på vegne af{" "}
            <span className="fw-semibold">{lawyerName}</span>
          </>
        ) : (
          <>Du er logget ind med fuldmagt</>
        )}
        {delegateName ? (
          <>
            {" "}
            som <span className="fw-semibold">{delegateName}</span>
          </>
        ) : null}
      </p>
    </div>
  );
};

export default DelegationBanner;
